module.exports = __webpack_public_path__ + "images/kaitori_bonus_lp/step-1-img-pc@2x_72de04cfc916f1dcb9e59230ca624167.png";